import { event } from '@abyss/web/tools/event';

export const widgetPageLoadEvent = (input) => {
  const { pageName } = input;
  event('PSX_DETAILS_WIDGET_PAGE_LOAD', {
    pageName: pageName?.toLowerCase().replaceAll('-', ''),
  });
};